export const SNAP_SCROLL_SPACE_BETWEEN = '0px'
export const SNAP_SCROLL_DEBOUNCE_TIME = 200
export const SNAP_SCROLL_IS_HORIZONTAL = 'true'
export const SNAP_SCROLL_INDICATOR_SYMBOL = '●'
export enum SnapScrollDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}
export enum SnapScrollSnapType {
  Mandatory = 'mandatory',
  Proximity = 'proximity',
  None = 'none',
}
